





































import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalDueDiligenceRecord",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalDueDiligenceRecord extends Vue {
  get fetchData() {
    return api.externalDueDiligenceRecord.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "dueDiligenceRecordDetail",
      params: { id: dto.id!.toString() },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
